import React from 'react'
function Pricing() {
    return (
        <div className='container mt-5 mb-5'>
            <div className="row mt-5">
                <div className='col-4'>
`                   <h1 className='m-3'>Unbeatable Pricing</h1>
                    <p className="text-muted">We pioneered the concept of discount broking and price transparency in india.Flat fees and no hidden charges.</p>
                    <a href='#' style={{textDecoration:"None"}}> See Pricing <i class="fa-solid fa-arrow-right-long"></i></a>
                </div>
                <div className='col-2'>
                    
                </div>
                <div className='col-6 mt-5'>
                    <div className='row text-center'>
                        <div className='col border p-2 '>
                            <h1 className=' p-2 '>&#8377;0</h1>
                            <p className=' p-2 '>Free equity delivery and direct mutual fund</p>
                        </div>
                        <div className='col border p-2'>
                            <h1 className=' p-2 '>&#8377;0</h1>
                            <p className=' p-2 '>Free equity delivery and direct mutual fund</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}

export default Pricing;